import api from "../../api";
import { formatArrayToElSelect } from "./../../utils";

const state = {
  status: "",
  list: [],
  customer_services: [],
  customerServicesEmployee: [],
  customerServicesEmployeeId: []
};

const getters = {
  getCustomerServiceSelector: (state) => {
    //console.log("customer_services: ",state.customer_services)
    /*
    console.log("customer_services_Formated: ",formatArrayToElSelect(state.customer_services, {
      label: "FullName"
    }))
    */
    return formatArrayToElSelect(state.customer_services, {
      label: "FullName"
    });
  },
  getCustomerServiceById: (state) => (id) => {
    return state.customer_services.find((f) => f.Id === id);
  },
  getCustomerServiceByEmployeeId: (state) => {
    return state.customerServicesEmployeeId;
  },
  getCustomerServiceByEmployeeIdSelector: (state) => (id) => {
    return state.customerServicesEmployeeId.find((f) => f.value === id).value;
  },
  getCustomerServicesEmployee: (state) => {
    //console.log("customer_services: ",state.customerServicesEmployee)
    return state.customerServicesEmployee;
  }
};

const actions = {
  fetchCustomerServices: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/users/CustomerServices")
        .then((resp) => {
          commit("success");
          commit("SET_CUSTOMER_SERVICES", resp.data);
          resolve(resp.data);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  fetchCustomerServicesEmployee: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/users/CustomerServicesEmployee")
        .then((resp) => {
          //console.log("data resp: ",resp.data)
          commit("success");
          commit("SET_CUSTOMER_SERVICES_EMPLOYEE", resp.data);
          resolve(resp.data);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  },
  fetchCustomerServicesEmployeeId: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/users/customerServicesEmployeeId")
        .then((resp) => {
          commit("success");
          commit("SET_CUSTOMER_SERVICES_EMPLOYEE_ID", resp.data);
          resolve(resp.data);
        })
        .catch((error) => {
          commit("error");
          reject(error);
        });
    });
  }
};

const mutations = {
  loading: (state) => (state.status = "loading"),
  success: (state) => (state.status = "success"),
  error: (state) => (state.status = "error"),
  list: (state, list) => {
    state.list = list;
  },
  SET_CUSTOMER_SERVICES: (state, payload) => {
    state.customer_services = payload;
  },
  SET_CUSTOMER_SERVICES_EMPLOYEE: (state, payload) => {
    state.customerServicesEmployee = payload;
  },
  SET_CUSTOMER_SERVICES_EMPLOYEE_ID: (state, payload) => {
    state.customerServicesEmployeeId = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
